
import { Component, Vue } from 'vue-property-decorator';
import { store } from '@/store';
import { appName, designMode } from '@/env';
import { readIsLoggedIn, readLoginError } from '@/store/main/getters';
import { dispatchCheckLoggedIn, dispatchLogIn } from '@/store/main/actions';
import ApplicationFooter from '@/components/ApplicationFooter.vue';
import { saveState, toBoolean } from '@/utils';

const startRouteGuard = async (to, from, next) => {
  await dispatchCheckLoggedIn(store);
  if (readIsLoggedIn(store)) {
    next('/main');
  } else {
    next();
  }
};

@Component({
  components: {
    ApplicationFooter,
  },
})
export default class Login extends Vue {
  public email: string = '';
  public password: string = '';
  public appName = appName;

  public get loginError() {
    return readLoginError(this.$store);
  }

  public cancel() {
    this.$router.push('/');
  }

  public submit() {
    dispatchLogIn(this.$store, { username: this.email, password: this.password });
  }

  public async googleLogin() {
    saveState('callback-login');
    this.$router.push('/google-callback');
  }

  public beforeRouteEnter(to, from, next) {
    if (toBoolean(designMode)) {
      next();
    } else {
      startRouteGuard(to, from, next);
    }
  }

  public beforeRouteUpdate(to, from, next) {
    if (toBoolean(designMode)) {
      next();
    } else {
      startRouteGuard(to, from, next);
    }
  }
}
